document.addEventListener('DOMContentLoaded', function () { 
  /** splide slider */
  var splideElms = document.querySelectorAll( '.splide' );

  splideElms.forEach(e => {
    var splideSettings;
    if (e.classList.contains('splide--media__gallery')) {

      splideSettings = { 
        "direction": "ttb",
        "height": "60rem", 
        "autoHeight": true,
        "perPage": 1,
        "perMove": 1,
        "autoplay": false,
        "wheel": true,
        "pagination": false, 
        "arrow": false,
        "gap": "1rem",
      }

      let mediaGallery = new Splide( e , splideSettings );
      mediaGallery.mount();

    }
    else {
      splideSettings = e.dataset.splide;
      new Splide( e , splideSettings ).mount();
    }
  });


  /* hide opened collapsible content in product page */
  const collapsibleContents = document.querySelectorAll('.accordion')
  if(collapsibleContents) { 
    collapsibleContents.forEach(collapsibleContent => {
      collapsibleContent.addEventListener("click", function() { 
        collapsibleContents.forEach(content => {
          if (content !== collapsibleContent) {
            content.querySelector('details').removeAttribute("open")
          }
        });
      })
    })
  }

});